// extracted by mini-css-extract-plugin
export default {"filters":"Examinations_filters__E8hN1","pagination":"Examinations_pagination__xPGdj","table":"Examinations_table__jKwYJ"};